import Loader from 'react-loaders'
import './index.scss'
import React, { useState, useEffect, useRef } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import emailjs from '@emailjs/browser'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

function Contact() {
  const [letterClass, setLetterClass] = useState('text-animate')
  const refForm = useRef()
  // const btn = document.getElementById('button')

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => {
      clearTimeout(timeout) // Membersihkan timeout jika komponen di-unmount sebelum timeout tercapai
    }
  }, [])

  const sendEmail = (e) => {
    e.preventdefault()

    //   const serviceID = 'default_service'
    //   const templateID = 'template_mc83m3b'

    //   emailjs.sendForm(serviceID, templateID, refForm).then(
    //     () => {
    //       btn.value = 'Send Email'
    //       alert('Sent!')
    //     },
    //     (err) => {
    //       btn.value = 'Send Email'
    //       alert(JSON.stringify(err))
    //     }
    //   )

    emailjs
      .sendForm(
        'default_service',
        'template_mc83m3b',
        refForm.current,
        'T8165I0d3iUGnJS5k'
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, please try again')
        }
      )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              strArray={['C', 'O', 'N', 'T', 'A', 'C', 'T', ' ', 'M', 'E']}
              idx={15}
              letterClass={letterClass}
            />
          </h1>
          <p>
            I am interested in freelance opportunities - especially on ambitious
            or large projects. However, if you have any other requests or
            questions, don't hesitate to contact me using below form either.
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input
                    placeholder="Name"
                    type="text"
                    name="from_name"
                    id="from_name"
                    required
                  />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="user_email"
                    id="user_email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    id="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    id="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input
                    type="submit"
                    className="flat-button"
                    value="SEND"
                    id="button"
                  />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Shiddiq Pratomo,
          <br />
          Indonesia,
          <br />
          Jl Tangkubanprau Bendan <br />
          Pekalongan, Jawa Tengah <br />
          <br />
          <span>pratomosidiq123@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[-6.897018, 109.664113]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[-6.897018, 109.664113]}>
              <Popup>Home Sweet Home :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
